/* eslint-disable no-param-reassign */
import angular from 'angular';

import template from './upload-file.html';
import './upload-file.less';

angular.module('myConsultApp').directive('uploadFile', () => {
  return {
    template,
    restrict: 'E',
    scope: {
      id: '@',
      validationOptions: '@',
      maxSize: '@',
      accept: '@',
      file: '=',
      isLoading: '=',
      onChange: '=',
    },
    compile: (element, attrs) => {
      // default attribute values
      if (!attrs.id) {
        attrs.id = 'upload-file';
      }
      if (!attrs.maxSize) {
        attrs.maxSize = '6MB';
      }
      if (!attrs.validationOptions) {
        attrs.validationOptions =
          "{size: {min: 0, max: '6MB'}, pattern:'.jpg,.jpeg,.png,.gif,.pdf'}";
      }
      if (!attrs.accept) {
        attrs.accept = "'image/*,application/pdf'";
      }
    },
  };
});
